
import { TASK_STATUS, JOB_STATUS, DEFAULT_IMAGE } from '@/utils/const';
import Api from '@/utils/api';

export default {
  props: {
    Task: {
      required: true,
    },
  },
  data () {
    return {
      statusTask: TASK_STATUS,
      defaultImage: DEFAULT_IMAGE,
      jobStatus: JOB_STATUS,
      additionalData: Array(),
      showToogle: false,
      arrayDocType: [],
      downloadIcon: true,
      toggleIcon: false,
      otherLanguages: {},
    };
  },
  created () {
    this.parseArray();
    this.prepareOtherLanguages();
  },
  computed: {
    taskJobsCount() {
      if (this.$route.name == 'projects') {
        return this.Task.JobCount || 0;
      }
      if (this.$route.name == 'project_groups') {
        return this.Task.TargetLanguage ? this.Task.TargetLanguage.length || 0 : 0;
      }
      return 0;
    },
  },
  methods: {
    prepareOtherLanguages () {
      if (this.Task.TargetLanguage.length) {
        this.otherLanguages = this.Task.TargetLanguage.length == 1
          ? this.Task.TargetLanguage : this.Task.TargetLanguage.filter((element, ix) => {
            if (ix !== 0) return element;
          });
      }
    },

    downloadFile () {
      this.downloadIcon = false;

      Api.projects
        .downloadFile(this.Task.DownloadFile.Link)
        .then((response) => {
          if (response.data) {
            const blob = new Blob([this.response]);
            const link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = this.Task.DownloadFile.Name;
            link.click();
          } else {
            this.$root.$emit('notification', {
              message: 'File not found',
              type: 'error',
              show: true,
            });
          }

          this.downloadIcon = true;
        });
    },

    /**
         * Select view
         */
    selectDataView () {
      return this.$route.params.view ? this.$route.params.view : 'timeline';
    },
    moreBlurHandler() {
      setTimeout(() => {
        if (this.showToogle) {
          this.showToogle = false;
          this.$emit('needed-height', 0);
        }
      }, 250);
    },
    showToggle (id) {
      if (this.toggleIcon) {
        return;
      }

      this.showToogle = !this.showToogle;

      if (this.showToogle) {
        this.toggleIcon = !this.toggleIcon;
        let apiTask = new Promise((res) => {});
        if (this.$route.name === 'projects') {
          apiTask = Api.tasks
            .getTaskJob(id)
            .then((response) => {
              if (response.data.Status) {
                this.additionalData = response.data.Data.filter((_, i) => i < 3);
                this.additionalData.forEach((item) => {
                  item.ExecutorDataJson = JSON.parse(item.ExecutorDataJson) !== null ? JSON.parse(item.ExecutorDataJson)[0] : null;
                  item.WordsDataJson = JSON.parse(item.WordsDataJson) !== null ? JSON.parse(item.WordsDataJson)[0] : null;
                  item.StatusDataJson = JSON.parse(item.StatusDataJson) !== null ? JSON.parse(item.StatusDataJson)[0] : null;
                });
              }
              this.toggleIcon = false;
            });
        }

        if (this.$route.name === 'project_groups') {
          apiTask = Api.projects
            .getProjectTask({
              id: id,
              page: 1,
              perPage: 3,
            })
            .then((response) => {
              if (response.data.Status) {
                this.additionalData = response.data.Data;
                this.additionalData.forEach((item) => {
                  item.WordsDataJson = JSON.parse(item.WordsDataJson) !== null ? JSON.parse(item.WordsDataJson) : null;
                });
              }
              this.toggleIcon = false;
            });
        }
        apiTask.finally(() => {
          this.$refs.morelist.focus();
          this.$emit('needed-height', this.$el.offsetTop + this.$el.offsetHeight + this.$refs.morelist.offsetHeight);
          setTimeout(() => {
            this.$refs.morelist.scrollIntoView({
              behavior: 'smooth',
              block: 'nearest',
            });
          }, 100);
        });
      } else {
        this.$emit('needed-height', 0);
      }
    },
    parseArray () {
      const parseArray = [];
      if (this.Task.IndustryFeldsAndBranches) {
        this.Task.IndustryFeldsAndBranches.forEach((item) => {
          parseArray.push(item.split(','));
        });
        this.arrayDocType = parseArray.flat();
      }
      if (this.Task.IndustryFieldsData) {
        this.Task.IndustryFieldsData.forEach((item) => {
          parseArray.push(item.split(','));
        });
        this.arrayDocType = parseArray.flat();
      }
    },
  },
};
